export default "__VITE_ASSET__vvVLQrit__"